import * as moment from 'moment';
import 'moment/min/locales';

const convertSecondsToTime = (seconds) => {
  const parsed = parseInt(seconds, 10);
  return moment.duration(parsed, 'seconds');
};

const DateFormats = {
  RegularDate: 'L',
  RegularDateTime: 'L H:mm:ss',
  TextDateTime: 'll LTS',
  TextDate: 'll',
  MonthAndYear: 'MM/YYYY',
  StandardDate: 'YYYY-MM-DD',
  notifDateTime: 'MMM DD, YYYY  |  H:mm:ss',
  notifDate: 'MMM DD, YYYY',
  notifTime: 'H:mm:ss',
  StandardEuropeanDateFormat: 'DD/MM/YYYY'
};

const formatDateUTCAs = (dateObject, dateFormat) => {
  return moment.utc(dateObject).format(dateFormat);
};

const formatDateAs = (dateObject, dateFormat) => {
  return moment(dateObject).format(dateFormat);
};

const formatDateFromNow = (dateObject) => {
  return moment.utc(dateObject).fromNow();
};

const getNavigatorLanguage = () => {
  const splitLanguage = (lng) => (lng.indexOf('-') > -1 ? lng.substr(0, 2) : lng);
  if (navigator.languages && navigator.languages.length) {
    return splitLanguage(navigator.languages[0]);
  }
  const language = navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
  return splitLanguage(language);
};

const getTimeFormatted = (t, seconds) => {
  const time = convertSecondsToTime(seconds);
  const minutes = Math.floor(time.asMinutes());
  const hours = Math.floor(time.asHours());
  const days = Math.floor(time.asDays());

  // When hours bigger than 24 show days instead
  if (hours > 24) {
    return `${t('timeDays', { count: days })}`;
  }
  // When minutes bigger than 60 show hours instead
  if (minutes > 60) {
    return `${t('timeHours', { count: hours })}`;
  }
  return `${t('timeMinutes', { count: minutes })}`;
};

moment.locale(getNavigatorLanguage());

const getDayOfWeek = (dateString) => {
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayIndex = moment(dateString).day();
  return daysOfWeek[dayIndex];
};

export { convertSecondsToTime, formatDateAs, formatDateUTCAs, formatDateFromNow, getTimeFormatted, DateFormats, getDayOfWeek };
